module.exports = __webpack_public_path__ + "img/13.0a122af9.png";